import { Component } from '@angular/core';
import { LeaveData } from '../../classes/leave-data.class';
import { DatabaseService } from '../../services/database.service';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'app-dialog-add-leave',
  templateUrl: '../../templates/dialogs/dialog-add-leave.component.html'
})

export class DialogAddLeaveComponent{

  LeaveData = new LeaveData();
  leaveType = [{ code: "1", name: "Funeral"},{ code: "2", name: "Sick Leave"},{ code: "3", name: "Vacation Leave"}];

  constructor(private database:DatabaseService,public dialog: MdDialog) {
  }

  requestLeave(){
    this.LeaveData.from = this.LeaveData.from.toString(); // Firebase support nie hierdie date formaat nie.
    this.LeaveData.to = this.LeaveData.to.toString(); // Firebase support nie hierdie date formaat nie.
    this.LeaveData.status = "Pending"
    this.database.createLeave(this.LeaveData);
    this.dialog.closeAll();
  }
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/dialogs/dialog-add-leave.component.ts